export default __webpack_public_path__ + "static/media/genarate-document.b263d1eb.svg";